import {
  Box,
  Button,
  Card,
  CardBody,
  Flex,
  Heading,
  Image,
  List,
  Stack,
  Text,
  UnorderedList,
  ListItem,
} from "@chakra-ui/react";
import React from "react";
import pdf from "../Assert/Kiran_Wankhade_Resume.pdf";

import avatar from "../kiran_photo.png";

import { FaAngleRight, FaGithub, FaLink } from "react-icons/fa";

import "./AboutMe.css";
import { Link } from "react-router-dom";

const AboutMe = () => {
  return (
    <>
      <hr
        className="hrClass"
        style={{
          height: 5,
          backgroundColor: "#29242a",
        }}
      />
      <div id="aboutme" className="aboutme">
        <Box className="mainaboutme" color={"#dcdcda"}>
          <Box>
            <Heading
              textDecoration={"underline"}
              fontSize={50}
              textUnderlineOffset="10px"
              textDecorationStyle={"solid"}
              textDecorationColor={"orange"}
              color={"#15110D"}
            >
              About Me..!{" "}
            </Heading>
            <br />
          </Box>

          <div className="aboutmeClass">
            <Box flex={7} className="content" w={"100%"} textAlign="left">

              <Text className="textAboutme" color={"#15110D"}>
                Full Stack Developer with 6 months of practical experience in
                designing, developing, and implementing diverse applications and
                solutions across various programming languages.Eager to apply my extensive development knowledge and hands-on technical skills in a dynamic role as a Full Stack Developer.
              </Text>
              <Box display="flex" flexDirection="column">
              <Box className="box-container">
                <Box className="box" textAlign={"left"}>
                  <Text className="textAboutmespan" color={"#15110D"}>
                    <span style={{ color: "#15110D",fontWeight:"bold" }}> email : </span>{" "}
                    kiranwankhade7738@gmail.com
                  </Text>
                  <Text className="textAboutmespan" color={"#15110D"}>
                    <span span style={{ color: "#15110D",fontWeight:"bold" }}>
                      {" "}
                      place :{" "}
                    </span>{" "}
                    Bhusawal, India - 425201
                  </Text>
                </Box>
              </Box>

              <Box textAlign={"left"}>
                <a href={pdf} download>
                  <Button
                    bg={"orange"}
                    className="resumeBtn"
                    _hover={{ color: "black", backgroundColor: "yellow" }}
                    onClick={() => {
                      let url =
                        "https://drive.google.com/file/d/1EMEVNUthn9N6BL4VRy9gAvVWpap44duz/view?usp=share_link";
                      window.open(url, "_blank");
                    }}
                  >
                    Resume{" "}
                    <span>
                      <FaAngleRight />
                    </span>
                  </Button>
                </a>
              </Box>
            </Box>
            </Box>

            <div id="aboutImgBox">
              <img className="homeimg" src={avatar} alt="home" />
            </div>
          </div>
          <br />
          {/* <Heading color={"#15110D"}>Professional Experience</Heading>
          <br /> */}

          {/* <div className="expClass">
            <Box className="expAbout">
              <Box className="exp">
                <Text
                  className="textAboutmespan"
                  color={"#15110D"}
                  fontWeight={"bold"}
                >
                  SDE-Intern (Remote)
                </Text>
                <Text className="textAboutmespan" color={"#15110D"}>
                  Masai School (Bangalore)
                </Text>
                <Text className="textAboutmespan" color={"#15110D"}>
                  Sep 2023 - Present
                </Text>
                <UnorderedList className="textAboutmespan" color={"#15110D"}>
                  <ListItem> Worked on a live project with the team</ListItem>
                  <ListItem>Learned new basic libraries.</ListItem>
                  <ListItem>Developed frontend web pages</ListItem>
                </UnorderedList>
                <br />
                <Text color={"#15110D"} fontWeight={"bold"}>
                  Projects:
                </Text>
                <UnorderedList className="textAboutmespan" color={"#15110D"}>
                  <ListItem>
                    <Flex
                      flexDirection={"row"}
                      gap={"1rem"}
                      alignItems={"center"}
                    >
                      <Text> Masai Dashboard </Text>
                      <a
                        href="https://mock-onward-fe-rho.vercel.app/login"
                        target="_blank"
                        rel="noreferrer"
                      >
                        <Button
                          background="orange"
                          color={"black"}
                          _hover={{ color: "white" }}
                          padding={"1px"}
                        >
                          <Text as={"span"}>
                            <FaLink />
                          </Text>
                        </Button>
                      </a>
                      <a
                        href="https://github.com/Albin05/mock-onward-fe"
                        target="_blank"
                        rel="noreferrer"
                      >
                        <Button
                          background="orange"
                          color={"black"}
                          _hover={{ color: "white" }}
                          padding={"1px"}
                        >
                          <Text as={"span"}>
                            <FaGithub />
                          </Text>
                        </Button>
                      </a>
                    </Flex>
                  </ListItem>
                  <br />
                  <ListItem>
                    <Flex
                      flexDirection={"row"}
                      gap={"1rem"}
                      alignItems={"center"}
                    >
                      <Text> CN (College Network) </Text>
                      <a
                        href="https://sharda.prepleaf.com/"
                        target="_blank"
                        rel="noreferrer"
                      >
                        <Button
                          background="orange"
                          color={"black"}
                          _hover={{ color: "white" }}
                        >
                          <Text as={"span"} margin={"-10px"}>
                            <FaLink />
                          </Text>
                        </Button>
                      </a>
                    </Flex>
                  </ListItem>
                </UnorderedList>
                <br />
              </Box>

              <Box className="exp">
                <Text
                  className="textAboutmespan"
                  color={"#15110D"}
                  fontWeight={"bold"}
                >
                  iOS Developer
                </Text>
                <Text className="textAboutmespan" color={"#15110D"}>
                  Inceptive Technologies (Pune)
                </Text>
                <Text className="textAboutmespan" color={"#15110D"}>
                  July 2019 - Jan 2020
                </Text>
                <UnorderedList className="textAboutmespan" color={"#15110D"}>
                  <ListItem>
                    {" "}
                    Worked on creating a web application for a tablet that has
                    statics RAM
                  </ListItem>
                  <ListItem>Learned basic WordPress.</ListItem>
                  <ListItem>Client Handling</ListItem>
                </UnorderedList>
              </Box>
            </Box>

            
          </div> */}

          <br />
          <br />
        </Box>
      </div>
    </>
  );
};

export default AboutMe;
